jQuery(document).foundation();
AOS.init({
  duration: 1000,
});
